const toggleNavbar = () => {
  const navbarNav = document.getElementById('navbarNav');
  if (navbarNav.style.maxHeight) {
    navbarNav.style.maxHeight = null;
  } else {
    navbarNav.style.maxHeight = navbarNav.scrollHeight + 'px';
  }
};

const blurLink = (element) => {
  element.blur();
};

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener('click', (e) => {
    e.preventDefault();

    const targetID = anchor.getAttribute('href');

    document.querySelector(targetID).scrollIntoView({
      behavior: 'smooth'
    });

    anchor.blur();
  });
});
